import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
import { format as dateFnsFormat, isValid } from "date-fns";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/** Formats a date value as dd/MM/yyyy — always locale-independent */
export function fmtDate(v: string | Date | null | undefined): string {
  if (!v) return "—";
  try {
    const d = new Date(v as string);
    if (!isValid(d)) return "—";
    return dateFnsFormat(d, "dd/MM/yyyy");
  } catch { return "—"; }
}

/** Formats a date-time value as dd/MM/yyyy hh:mm a — always locale-independent */
export function fmtDateTime(v: string | Date | null | undefined): string {
  if (!v) return "—";
  try {
    const d = new Date(v as string);
    if (!isValid(d)) return "—";
    return dateFnsFormat(d, "dd/MM/yyyy hh:mm a");
  } catch { return "—"; }
}
